import makeStyles from '@material-ui/styles/makeStyles'

export default makeStyles(() => ({
    button: {
        paddingBottom: 0,
        '&:hover': {
            background: 'none'
        }
    }
}))
